import { Repo } from '@aragon/connect-core';
export async function parseRepo(result, organization) {
    var _a, _b, _c, _d, _e, _f, _g;
    const repo = (_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.app) === null || _b === void 0 ? void 0 : _b.repo;
    if (!repo) {
        throw new Error('Unable to parse repo.');
    }
    const data = {
        address: repo === null || repo === void 0 ? void 0 : repo.address,
        artifact: (_c = repo === null || repo === void 0 ? void 0 : repo.lastVersion) === null || _c === void 0 ? void 0 : _c.artifact,
        contentUri: (_d = repo === null || repo === void 0 ? void 0 : repo.lastVersion) === null || _d === void 0 ? void 0 : _d.contentUri,
        manifest: (_e = repo === null || repo === void 0 ? void 0 : repo.lastVersion) === null || _e === void 0 ? void 0 : _e.manifest,
        name: repo === null || repo === void 0 ? void 0 : repo.name,
        registry: (_f = repo === null || repo === void 0 ? void 0 : repo.registry) === null || _f === void 0 ? void 0 : _f.name,
        registryAddress: (_g = repo === null || repo === void 0 ? void 0 : repo.registry) === null || _g === void 0 ? void 0 : _g.address,
    };
    return Repo.create(data, organization);
}
//# sourceMappingURL=repos.js.map